// src/ui/features/calculator/hooks/useProGate.js
import { useMemo, useState } from "react";

export function useProGate({ isSignedIn, isPro }) {
  const [authOpen, setAuthOpen] = useState(false);
  const [upgradeOpen, setUpgradeOpen] = useState(false);
  const [proGateMsg, setProGateMsg] = useState("");

  const canUseProFeatures = Boolean(isSignedIn && isPro);
  const proLocked = !canUseProFeatures;

  const proLockText = !isSignedIn
    ? "Lifetime access for only £4.99:"
    : "Lifetime access for only £4.99:";

  const proLockedMessage = useMemo(() => {
    if (!isSignedIn) return "Unlock the following for a one-time fee.";
    if (!isPro) return "Upgrade to Pro to unlock analysis and export.";
    return "";
  }, [isSignedIn, isPro]);

  const requirePro = (fn) => {
    if (!isSignedIn) {
      setProGateMsg("Please sign in to use Analyse, Analysis, and Export.");
      setAuthOpen(true);
      return;
    }
    if (!isPro) {
      setProGateMsg("Upgrade to Pro to unlock Analyse, Analysis, and Export.");
      setUpgradeOpen(true);
      return;
    }
    fn?.();
  };

  const onRequestPro = () => {
    if (!isSignedIn) setAuthOpen(true);
    else setUpgradeOpen(true);
  };

  return {
    authOpen,
    setAuthOpen,
    upgradeOpen,
    setUpgradeOpen,
    proGateMsg,
    setProGateMsg,

    canUseProFeatures,
    proLocked,
    proLockText,
    proLockedMessage,

    requirePro,
    onRequestPro,
  };
}
